import React from "react";
import { Badge, Select } from "@telia/teddy";
import _get from "lodash/get";
import { connect, useDispatch } from "react-redux";
import {
    FORM_ID,
    IDENTIFICATION_METHODS,
    IdentificationMethod as IdentificationMethodType,
} from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { setSelectedIdentificationMethod } from "../../../state/actions";
import "./IdentificationMethod.less";
import { getFormById } from "../../../state/selectors/formSelectors";
import { getAllowedIdentificationMethods } from "../../../state/selectors/selectors";

interface Props {
    allowedMethods: IdentificationMethodType[];
    form: Form;
}

const IdentificationMethod: React.FC<Props> = ({ allowedMethods, form }) => {
    const dispatch = useDispatch();
    return (
        <Select
            errorText="Error text"
            label="Legitimeringsmåte"
            name="option-select"
            onValueChange={(value) => {
                dispatch(setSelectedIdentificationMethod(value as IdentificationMethodType));
                return value;
            }}
            options={allowedMethods}
            placeholder="Velge..."
            validationState="valid"
            value={_get(form, "values.selectedIdentificationMethod")}
            className="identification-method__select"
        >
            <Select.Trigger validationState="valid">
                <Select.Value placeholder="Velge..." />
            </Select.Trigger>
            <Select.Portal>
                <Select.Content>
                    <Select.Viewport>
                        {allowedMethods.map((key) => (
                            <Select.Item key={key} value={key}>
                                <span>
                                    {IDENTIFICATION_METHODS[key]}
                                    {key === "BANK_ID" && (
                                        <Badge variant="attention" className="identification-method__recommended-label">
                                            Anbefalt
                                        </Badge>
                                    )}
                                </span>
                            </Select.Item>
                        ))}
                    </Select.Viewport>
                </Select.Content>
            </Select.Portal>
        </Select>
    );
};

const mapStateToProps = (state: RootState) => ({
    allowedMethods: getAllowedIdentificationMethods(state),
    form: getFormById(state, FORM_ID.CUSTOMER_IDENTIFICATION),
});

export default connect(mapStateToProps)(IdentificationMethod);
